import { observer } from 'mobx-react-lite';
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
import ConfigPage from '../../views/ConfigPage';
import ContactsImportPage from '../../views/ContactsImportPage';
import CourseImportPage from '../../views/CourseImportPage';
import DocumentsPage from '../../views/DocumentsImportPage';
import FireSafetyPage from '../../views/FireSafetyPage';
import ImportPage from '../../views/ImportPage';
import LoginPage from '../../views/LoginPage';
import MaexchenArticlesImportPage from '../../views/MaexchenArticlesImportPage';
import MaexchenOrdersPage from '../../views/MaexchenOrdersPage';
import MaexchenProductsImportPage from '../../views/MaexchenProductsImportPage';
import MaexchenUsersOverview from '../../views/MaexchenUsersOverview';
import MaexchenUsersPage from '../../views/MaexchenUsersPage';
import NewsPage from '../../views/NewsPage';
import NotificationsPage from '../../views/NotificationsPage';
import SupplierImportPage from '../../views/SupplierImportPage';
import VideoCategoryPage from '../../views/VideoCategoryPage';
import VideoDetailPage from '../../views/VideoDetailPage';
import Sidebar from '../SidebarDrawer';

import { useStore } from '../../store/context';

const RequireAuth = observer(() => {
  const location = useLocation();

  const { authStore } = useStore();

  if (authStore?.loading) return <p>Loading user...</p>;

  if (location.pathname !== '/orders')
    if (!authStore?.isFrontendAdmin)
      return <Navigate to="/orders" state={{ from: location }} />;

  if (!authStore?.userData) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return <Outlet />;
});

const Router: React.FunctionComponent = observer(() => {
  const { authStore } = useStore();

  return (
    <BrowserRouter>
      {authStore?.userData && <Sidebar />}
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<RequireAuth />}>
          <Route path="/" element={<NewsPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/products" element={<ImportPage />} />
          <Route path="/firesafety-import" element={<FireSafetyPage />} />
          <Route path="/documents-import" element={<DocumentsPage />} />
          <Route path="/seller-import" element={<SupplierImportPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/config" element={<ConfigPage />} />
          <Route path="/videos" element={<VideoCategoryPage />} />
          <Route path="/videos/:id" element={<VideoDetailPage />} />
          <Route path="/courses" element={<CourseImportPage />} />
          <Route path="/contacts" element={<ContactsImportPage />} />
          <Route
            path="/bonus-catalogue"
            element={<MaexchenProductsImportPage />}
          />
          <Route
            path="/material-list"
            element={<MaexchenArticlesImportPage />}
          />
          <Route path="/logs" element={<MaexchenUsersPage />} />
          <Route path="/overview" element={<MaexchenUsersOverview />} />
          <Route path="/orders" element={<MaexchenOrdersPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
});

export default Router;
